import { computed, getCurrentInstance } from 'vue';
export default {
  name: "Pagination",
  props: ["pageNo", "pageSize", "total", "continues"],
  //接受父组件传过来的参数
  setup(props) {
    const mitt = getCurrentInstance(); //调用全局事件总线的api
    const bus = mitt.appContext.config.globalProperties.mittBus;
    //计算属性
    let totalPage = computed(() => Math.ceil(props.total / props.pageSize)); //总页数（总数据/每页多少条数据 且向上取整）
    let startNumAndEndNum = computed(() => {
      //定义两个变量来储存起始页面数值和结束页面数值
      let start = 0;
      let end = 0;
      //当页面的总数小于连续页面数时
      if (totalPage.value < props.continues) {
        start = 1;
        end = totalPage.value;
      } else {
        //当页面总数大于连续页面数时
        //起始页面数值 = 当前页面值 - 连续页面值/2 且取整
        start = props.pageNo - parseInt(props.continues / 2);
        //结束页面数值 = 当前页面值 - 连续页面值/2 且取整
        end = props.pageNo + parseInt(props.continues / 2);
        //如果起始页面数 小于 1，
        if (start < 1) {
          start = 1;
          end = props.continues;
        }
        //如果结束页面数 大于 总页面数
        if (end > totalPage.value) {
          start = totalPage.value - props.continues + 1;
          end = totalPage.value;
        }
      }
      return {
        start,
        end
      };
    });
    //通过全局事件总线向父组件传递pageNo
    function sendPageNo(pageNo) {
      if (pageNo < 1) {
        pageNo = 1;
      }
      if (pageNo > totalPage.value) {
        pageNo = totalPage.value;
      }
      bus.emit('getPageNo', pageNo);
    }
    return {
      totalPage,
      startNumAndEndNum,
      sendPageNo
    };
  }
};